module.exports = __webpack_public_path__ + "img/erp_case9.5f1f0147.png";